import React, { useRef, useState } from 'react';
import Header from './Header';
import { checkValidData } from '../utils/Validate';
import { createUserWithEmailAndPassword,signInWithEmailAndPassword,updateProfile  } from "firebase/auth";
import { auth } from '../utils/Firebase';
import { useDispatch } from 'react-redux';
import { addUser } from '../utils/userSlice';
import { BACKDROP_IMG, USER_AVATAR } from '../utils/constant';

const Login = () => {
    const [isSignInForm,setIsSignInForm] = useState(true);
    const [errorMessage,setErrorMessage] = useState(null);
    const dispatch = useDispatch();

    const name = useRef(null);
    const email = useRef(null);
    const password = useRef(null);

    const handleButtonClick = () => {
        //validate form data
        const message = checkValidData(email.current.value,password.current.value);
        setErrorMessage(message);

        if(message) return;
        if(!isSignInForm) {
            //Sign Up Login
            createUserWithEmailAndPassword(auth, email.current.value,password.current.value)
                .then((userCredential) => {
                    // Signed up 
                    const user = userCredential.user;
                    updateProfile(user, {
                        displayName: name.current.value , photoURL: USER_AVATAR
                      }).then(() => {
                        // Profile updated!
                        const { uid, email, displayName,photoURL} = auth.currentUser;
                        dispatch(addUser({ uid: uid, email: email, displayName: displayName, photoURL:photoURL }));
                       
                        
                      }).catch((error) => {
                        // An error occurred
                        setErrorMessage(error.message);
                        
                      });
                    console.log(user);
                    
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    setErrorMessage(errorCode + "-" +errorMessage);
                });
        }
        else{
            //Sign In Logic
            signInWithEmailAndPassword(auth, email.current.value,password.current.value)
                .then((userCredential) => {
                    // Signed in 
                    const user = userCredential.user;
                    console.log(user)
                    
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    setErrorMessage(errorCode + "-" +errorMessage);
                });
        }
    };

    const toggleSignInForm = () => {
        setIsSignInForm(!isSignInForm);
    };
  return (
    <div>
        <Header />
        <div className='absolute'>
            <img className='h-screen object-cover md:w-screen md:bg-gradient-to-b md:from-black' src={BACKDROP_IMG}  alt='bg-img'  />
        </div>
 
    <form onSubmit={(e)=>e.preventDefault()} className='w-full md:w-3/12  absolute  p-12 bg-black my-36 mx-auto right-0 left-0  rounded-lg bg-opacity-80 text-white'>
        <h1 className='font-bold text-3xl py-4'>{isSignInForm ? "Sign In" : "Sign Up"}</h1>
        {!isSignInForm && <input ref={name} type='text' placeholder='Full Name' className='p-4 my-4 w-full rounded-sm bg-gray-600' />}
        <input ref={email} type='text' placeholder='Email Address' className='p-4 my-4 w-full rounded-sm bg-gray-600' />
        <input ref={password} type='password' placeholder='Password' className='p-4 my-4 w-full rounded-sm bg-gray-600' />
        <p className='text-red-500 font-bold text-lg py-2'>{errorMessage}</p>
        <button className='p-2 my-6 bg-red-700 w-full rounded-lg' onClick={handleButtonClick}>{isSignInForm ? "Sign In" : "Sign Up"}</button>
        <p className='py-4 cursor-pointer' onClick={toggleSignInForm}>{isSignInForm ? "New to Netflix? Sign Up Now" : "Already registered? Sign In Now"}</p>
    </form>

    </div>
  )
}

export default Login;